import { RuntimeProps } from "views";
import { isUAT } from "./debug";
import webapi from "./fetch";
import { UserInfos } from "../services/page/app";
import { GetReceiveCouponResp } from "optimus-front/lib/utils/zeusFetch";

var md5 = require("md5-node");

/** GetProducts */
enum ConfigKey {
	Client = "client",
	AppKey = "app_key",
	AppSecret = "app_secret",
}

enum ClientType {
	web = "web",
	mweb = "mweb",
	iphone = "iphone",
	android = "android",
}

const userInfoConfig = {
	[`${ConfigKey.AppKey}`]: {
		web: "FIQ79MXR",
		mweb: "V06GF3A2",
		iphone: "FQ8K3D1G",
		android: "A4H0P4JN",
	},
	[`${ConfigKey.AppSecret}`]: {
		web: "606caa95b19bc709syqx9cpl72kmmnzy",
		mweb: "f838905ddd031399ffdm8n3mymrrzomk",
		iphone: "66a97d7029dde7c2iycit1nfo34jks9a",
		android: "4ce19ca8fcd150a4w4pj9llah24991ut",
	},
};

export const getClient = (runtime: Partial<RuntimeProps>): ClientType => {
	const { isAndroid, isIOS, platform, isInApp } = runtime;
	let client = platform === "mweb" ? ClientType.mweb : ClientType.web;
	if (isInApp) {
		if (isAndroid) {
			client = ClientType.android;
		}
		if (isIOS) {
			client = ClientType.iphone;
		}
	}

	return client;
};

export const getAppInfo = (
	client: ClientType,
): {
	app_key: string;
	app_secret: string;
} => {
	const config = userInfoConfig;
	return {
		app_key: config[ConfigKey.AppKey][client] || "",
		app_secret: config[ConfigKey.AppSecret][client] || "",
	};
};

export const getMd5Sign = (props: { app_key: string; app_secret: string }) => {
	const { app_key, app_secret } = props;
	return md5(`${ConfigKey.AppKey}${app_key}${ConfigKey.AppSecret}${app_secret}`);
};
export interface ZeusParam {
	platform: string;
}
export const getGetProductsParams = (runtime: Partial<RuntimeProps>): UserInfos => {
	const { sid, sessionKey, visit, fav, cust } = runtime;
	const client = getClient(runtime);
	const { app_key, app_secret } = getAppInfo(client);
	return {
		app_key,
		app_secret,
		sid: sid,
		sessionkey: sessionKey,
		visit,
		fav,
		cust,
		sign: getMd5Sign({ app_key, app_secret }),
	};
};

/** 领取型优惠券 ReceiveCoupon  */
interface CouponsParams {
	client: "vela_pc" | "vela";
	isUat: string;
	language: string;
	currency: string;
	country: string;
	sid: string;
	sessionkey: string;
	campaign_key: string;
}

const API_UAT = "https://kdev0.tbox.me";
const API_ONLINE = "https://pro.lightinthebox.com";

const transformAddress = (isOnline: boolean, isMobile: boolean) => {
	return `${isOnline ? API_ONLINE : API_UAT}/litb-header-zeus/${isMobile ? "mweb" : "web"}`;
};

export function getCategories(params: CouponsParams, options): Promise<GetReceiveCouponResp> {
	return webapi<GetReceiveCouponResp>(
		"api/v1/rewardcredits/promotion/getCoupons",
		{ ...params },
		options,
	);
}

export const getGetCoupons = (
	params: CouponsParams,
	isMobile: boolean,
): Promise<GetReceiveCouponResp> => {
	const options = {
		fetchMethod: "GET",
		apiDomain: transformAddress(!isUAT(), isMobile),
	};
	return getCategories(params, options);
};
